import { createApp } from 'vue'
import App from './App.vue'
import './../node_modules/bulma/css/bulma.css';

createApp(App).mount('#app')
